// extracted by mini-css-extract-plugin
export default {"navigationDetail":"navigationDetail___TfG8r"};